/* globals urls, BasePopup, RSVP */

//var $ = jQuery.noConflict();

window.ReplacePaymentMethodPopup = function(popupName, cardToReplace, fullName){
    BasePopup.call(this, popupName);
    
    this.cardToReplace = cardToReplace;
    this.fullName = fullName;
    this.initCardOptionChangeEvent();
}

ReplacePaymentMethodPopup.prototype = Object.create(
    BasePopup.prototype
);
ReplacePaymentMethodPopup.prototype.constructor = ReplacePaymentMethodPopup;

ReplacePaymentMethodPopup.prototype.initPopupSubmitEvent = function(){
    $(this.submitButtonSelector).click({popup: this}, this.submitClicked);
};

ReplacePaymentMethodPopup.prototype.initCardOptionChangeEvent = function(){
    $('#kois-popup-contain input[name="SelectedCard"]').change(function(){
        if( $(this).val() === 'new' ){
            $('#kois-popup-contain .new-card--details').removeClass( 'hidden' );
        }
        else{
            $('#kois-popup-contain .new-card--details').addClass( 'hidden' );
        }
    });
};

ReplacePaymentMethodPopup.prototype.submitClicked = function(event){
    event.preventDefault();

    // Disable the button
    event.data.popup.disableSubmitButton();
    // Clear out any previous popup error messages
    event.data.popup.clearErrorMessage();

    // Gather required data
    var card = $('#kois-popup-contain input[name="SelectedCard"]:checked').val() || null;
    if( card !== 'new' ){
        // Attempt to update these enrollments with the specified existing card id
        event.data.popup.handleReplaceCard(card, null);
    }
    else{
        // Gather new card data and create promise for tokenization process
        var cardNumber = $('#kois-popup-contain input[name="card"]').val() || '';
        var exp = $('#kois-popup-contain input[name="expiration"]').val() || '00/0000';
        var expParts = exp.split('/');
        var tokenize = event.data.popup.tokenizeCard({
            number: cardNumber.replace(/\s/g, ''),
            name: this.fullname,
            expMonth: expParts.length === 2 ? expParts[0] : '00',
            expYear: expParts.length === 2 ? expParts[1] : '0000',
            cvc: $('#kois-popup-contain input[name="cvc"]').val() || null
        });

        // When tokenization promise resolves/rejects
        tokenize.then(function(token){
            // Attempt to update these enrollments with the specified token id (which will be stored against the user first)
            event.data.popup.handleReplaceCard(null, token);
        }).catch(function(err){
            // Display an error
            event.data.popup.setErrorMessage(err);
            // Enable the update button again
            event.data.popup.enableSubmitButton();
        });
    }
};

ReplacePaymentMethodPopup.prototype.handleReplaceCard = function(newCardId, tokenToStore){
    var self = this;
    var replaceCard = new this.RSVP.Promise(function( resolve, reject ){
        $.ajax({
            method: 'POST',
            url: urls.ajax,
            data: {
                action: 'replace_payment_method',
                oldCardId: self.cardToReplace,
                newCard: newCardId || 0,
                tokenToStore: tokenToStore || 0
            }
        })
        .done(function( response ) {
            if(response.success){
                resolve( true );
            }
            else{
                var message = (response.message ? response.message : 'An error occurred while attempting to replace your card.');
                reject( message );
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown){
            var message = 'An error occurred while attempting to replace your card.';
            reject( message );
        });
    });

    replaceCard.then(function(updated){
        // Refresh page
        window.location.reload();
    }).catch(function(err){
        self.setErrorMessage(err);
        // Enable the update button again
        self.enableSubmitButton();
    });
};

/**
* Attempts to tokenize the given credit card data using the QB Payments API tokenize endpoint.
* 
* @param Object cardData An object containing the following properties:
* 	number (the card number)
* 	name (the name on the card)
* 	expMonth (the month this card expires in MM format)
* 	expYear (the year this card expires in YYYY format)
* 	cvc (the cvc/security code for this card)
* 	OPTIONAL: address (object containing streetAddress, city, region, country, and postalCode properties)
* @see https://developer.intuit.com/docs/api/payments/tokens
* @returns Promise
*/
ReplacePaymentMethodPopup.prototype.tokenizeCard = function (cardData){
   // TODO: Currently depending on the payment gateway API URL, might want to decouple that
   var tokenizeURL = window.wc_intuit_payments_params.api_url || null;
   return new this.RSVP.Promise(function( resolve, reject ){
       if( tokenizeURL === null ){
           reject( 'Unable to find tokenization API URL' );
       }

       // Basic validation, thanks to the WC payment jQuery extension
       if(
           !$.payment.validateCardNumber( cardData.number ) || 
           !$.payment.validateCardExpiry( cardData.expMonth, cardData.expYear ) || 
           !$.payment.validateCardCVC( cardData.cvc )
       ){
           reject( 'A valid card number, expiration month/year, and security code are required' );
       }

       $.ajax({
           method: 'POST',
           url: tokenizeURL,
           contentType: 'application/json',
           data: JSON.stringify({card: cardData})
       })
       .done(function( response ) {
           if(response.value){
               resolve( response.value );
           }
           else{
               reject( 'An error occurred while attempting to tokenize your card' );
           }
       })
       .fail(function(jqXHR, textStatus, errorThrown){
           var errorMessage = 'An error occurred while attempting to tokenize your card';
           var errorMessageAdditional = '';
           if(jqXHR.responseJSON && jqXHR.responseJSON.errors){
               errorMessageAdditional = jqXHR.responseJSON.errors.reduce(function(acc, curr, index){
                   var prefix = index !== 0 ? ', ' : '';
                   return acc += prefix + (curr.moreInfo ? curr.moreInfo : curr.message);
               }, '');
           }

           if(errorMessageAdditional){
               errorMessage += ': ' + errorMessageAdditional;
           }
           reject( errorMessage );
       });
   });
};